<template>
  <!-- <transition name="fade"> -->
    <div class="right-sidebar" :class="{ 'dir-rtl' : language.rtl }">
      <div
        v-if="enableSlideOut"
        class="slide-out"
        :class="{
          'slide-out--slider-present': isSliderPresent,
          'slide-out--visible': isSlideOutVisible
        }"
      >
        <slot name="slide-out-slot"></slot>
        <div class="slide-out__toggle-button" @click="toggleSlideOut"><fa :icon="['far', 'chevron-left']" /></div>
      </div>

      <div class="right-sidebar__content">

        <div class="right-sidebar__logo-wrapper">
          <img v-if="logo" class="right-sidebar__logo" src="/assets/almouj-logo.png" :src-old="`${$store.state.assetsPath}${logo}`">
        </div>

        <div class="right-sidebar__minimap-wrapper">
          <transition name="fade" mode="out-in">
            <img v-if="minimap"  :src="`${$store.state.assetsPath}${minimap}`" :key="minimap" class="right-sidebar__minimap">
          </transition>
        </div>

        <div
          class="right-sidebar__heading"
          v-html="typeof heading === 'object' ? heading[language.code] : heading"
        ></div>

        <slot v-if="$scopedSlots['description']" class="right-sidebar__description" name="description"></slot>
        <div
          v-else
          class="right-sidebar__description"
          v-html="typeof description === 'object' ? description[language.code] : description"
        ></div>

        <div v-if="$scopedSlots['top-slot']" class="right-sidebar__top-slot">
          <slot name="top-slot"></slot>
        </div>

        <div 
          v-show="navigationItems.length"
          class="right-sidebar__nav-items-wrapper"
          :class="[
            { 'scrollable': isScrollable },
            navItemsScrollPosition
          ]"
          :style="{ height: navWrapperHeight}"
        >
          <div v-if="isScrollable" class="scroll-btn">
            <fa
              v-if="navItemsScrollPosition !== 'at-top'"
              :icon="['fas', 'arrow-circle-up']"
              fixed-width
              @click="$refs['nav-items'].scrollTop = 0"
            />
          </div>

          <div 
            class="right-sidebar__nav-items"
            ref="nav-items"
            @scroll="scrollNavItems"
          >
            <transition-group
              @before-enter="beforeEnter"
              @enter="enter"
              @leave="afterLeave"
            >        
              <router-link 
                v-for="(item, index) in navigationItems" 
                class="right-sidebar__nav-item touch"
                :class="{ 'dir-rtl' : language.rtl,
                  'right-sidebar__nav-item--disabled' : item.disabled,
                  'right-sidebar__nav-item--active': isNavItemActive(item)
                 }"
                tag="button"
                :data-index="index"
                :key="item.key ? item.key : item.to"
                :to="item.to"
              >
                <fa v-if="item.icon" fixed-width :icon="item.icon"/><span v-html="typeof item.label === 'object' ? item.label[language.code] : item.label"></span>
              </router-link >
            </transition-group>
          </div>

          <div v-if="isScrollable" class="scroll-btn">
            <fa
              v-if="navItemsScrollPosition !== 'at-bottom'"
              :icon="['fas', 'arrow-circle-down']"
              fixed-width
              @click="$refs['nav-items'].scrollTop = $refs['nav-items'].scrollHeight"
            />
          </div>
        </div>

        <div v-if="$scopedSlots['bottom-slot']" class="right-sidebar__bottom-slot" dir="ltr">
          <slot name="bottom-slot"></slot>
        </div>
      </div>
    </div>
  <!-- </transition> -->
</template>
<script>
export default {
  props: {
    enableSlideOut: { 
      type: Boolean,
      default: false
    },
    logo: String,
    minimap: String,
    heading: String,
    description: [String, Object],
    navigationItems: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      navWrapperHeight: `${4.4 * this.navigationItems.length}rem`,
      navItemsScrollPosition: 'at-top'
    }
  },

  computed: {
    isLiveSection () {
      return this.$route.path.match(/live/) ? true : false
    },

    isSlideOutVisible () {
      return this.$store.getters['sidebar/isSlideOutVisible']
    },

    language () {
      return this.$store.getters.language
    },

    isSliderPresent () {
      return this.$store.getters['sidebar/isSliderPresent']
    },

    isScrollable () {
      return this.navigationItems.length > 10 && this.isLiveSection
    }
  },

  mounted () {
    if (this.$refs.navItems) {
      this.$refs.navItems.scrollTop = 0
    }
  },

  methods: {
    beforeEnter (el) {
      el.style.opacity = 0
      el.style.transform = 'translateX(25%)'
    },

    enter (el) {
      setTimeout(() => {
        this.navWrapperHeight = `${4.4 * this.navigationItems.length}rem`
        setTimeout(() => {
          // TODO: set animating as a global state so we can also turn off the bottom bar navigation
          // this.animating = true
          el.style.opacity = null
          el.style.transform = 'translateX(0)'
          el.style.transition = `transform 0.6s, opacity 0.6s`
          // if (el.dataset.index == this.tags.length - 1) {
          //   this.animating = false
          // }
        }, (parseInt(el.dataset.index) + 2) * 100)
      }, 350)
    },

    afterLeave (el) {
      el.style.opacity = 0
      el.style.transition = `transform 0.3s, opacity 0.3s`
    },

    isNavItemActive (item) {
      if (this.$route.fullPath === item.to) {
        return true
      }
    },

    toggleSlideOut () {
      if (this.isSlideOutVisible) {
        this.$store.commit('sidebar/CLOSE_SLIDEOUT')
      } else {
        this.$store.commit('sidebar/OPEN_SLIDEOUT')
      }
    },

    scrollNavItems () {
      const scrollAmount = this.$refs['nav-items'].scrollTop
      const wrapperHeight = this.$refs['nav-items'].clientHeight
      const totalHeight = this.$refs['nav-items'].scrollHeight

      if (scrollAmount === 0) {
        this.navItemsScrollPosition = 'at-top'
      } else if (totalHeight ===  (scrollAmount + wrapperHeight)) {
        this.navItemsScrollPosition = 'at-bottom'
      } else {
        this.navItemsScrollPosition = 'at-mid'
      }
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";
@import "@/styles/_mixins.scss";
.right-sidebar {
  background: $dblue;
  height: 100rem;
  position: absolute;
  right: 0;
  top: 0;
  width: 40rem;
  z-index: 999;

  &__content {
    background: $dblue;
    display: grid;
    padding: 4rem 6rem 1rem 4rem;
    position: relative;
    grid-gap: 2rem;
    grid-template-columns: 1fr;
    // grid-template-rows: 8rem 18rem auto 1fr auto;
    grid-template-rows: 8rem auto auto 1fr auto;
    height: 100%;
  }

  &__logo-wrapper {
    // margin-bottom: 4rem;
    text-align: right;
  }  

  &__logo {
    max-width: 50%;
    max-height: 100%;
  }  

  &__minimap-wrapper {
    // margin-bottom: 4em;
    position: relative;
  }

  &__minimap {
    // width: 100%;
    // bottom: 0;
    // position: absolute;
    max-width: 100%;
    // max-height: 100%;
    // top: 0;
    // left: 0;
  }

  &__heading {
    color: $white;
    font-family: 'Canela';
    font-size: 3.25rem;
    font-weight: 400;
    letter-spacing: 0.05em;
    line-height: 1.2;
    // margin-bottom: 2rem;
    max-height: 13.2rem;
    position: relative;
    text-transform: capitalize;

    .ar & {
      font-family: 'GE Hili';
    }      
  }

  &__description {
    font-family: 'Nexa';
    font-size: 1.4rem;
    font-weight: 200;
    letter-spacing: 0.05em;
    line-height: 1.25;
    // margin-bottom: 2em;
    max-height: 70rem;
    font-weight: 200;

    .ar & {
      font-family: 'GE Dinkum';
    }    
  }  

  &__spacer {
    flex-grow: 1;
  }

  &__bottom-slot {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    margin: 0 -6rem -1rem -4rem;
    padding: 0 6rem 0 4rem;
    text-align: right;
  }

  &__btn {
    margin: 1rem 0 0 -0.5rem;
    color: $black;
    font-family: $touchscreen-font;
    font-size: 1.2rem;
    margin: 1rem 0 0;
    padding: 1rem 0 .8rem;
    text-transform: uppercase;
    width: 11rem;
    @include btn(#ccc, #ccc);
  }

  &__back {
    // border-right: 1px solid #fff;
    font-size: 1.8rem;
    font-weight: 200;
    text-transform: uppercase;
    width: 50%;
    padding: 1.5rem 0;
    text-align: left;

    svg {
      margin-right: 2rem;
    }
  }

  &__search {
    font-size: 1.8rem;
    font-weight: 200;
    text-transform: uppercase;
    width: 50%;
    padding: 2rem 0;
    text-align: right;

    svg {
      margin-right: 2rem;
    }
  }  

  &__nav-items-wrapper {
    position: relative;

    &.scrollable {
      display: flex;
      flex-direction: column;
      justify-content: center;

      // &::before,
      // &::after {
      //   content: '';
      //   font-size: 2rem;
      //   height: 2rem;
      //   position: absolute;
      //   text-align: center;
      //   width: 100%;
      //   z-index: 10;
      // }

      // &::before {
      //   background: linear-gradient(to bottom, $dblue, transparent);
      //   top: 0;
      // }

      // &::after {
      //   background: linear-gradient(to top, $dblue, transparent);
      //   bottom: 40.6rem;
      // }

      // &.at-top {
      //   &::before {
      //     content: none;
      //   }
      // }

      // &.at-bottom {
      //   &::after {
      //     content: none;
      //   }
      // }

      .right-sidebar__nav-items {
        max-height: 42.6rem;
        overflow: hidden;
        overflow-y: auto;

        &::-webkit-scrollbar {
          appearance: none;
          // height: 0;
          // width: 1rem;
        }

        &::-webkit-scrollbar-thumb {
          // border-radius: .75rem;
          // background-color: rgba(255, 255, 255, .5);
        }
      }

      .scroll-btn {
        font-size: 2rem;
        height: 3rem;
        text-align: center;
      }
      
    }
  }
    
  &__nav-items {
    // position: absolute;
    // left: 0;
    // bottom: 0;
    // width: 100%;

    svg {
      margin-right: 1em;
    }


    button {
      border-top: .05rem solid $white;
      color: $white;
      display: block;
      font-family: 'Nexa';
      font-size: 1.5rem;
      font-weight: 200;
      height: 4.4rem;
      letter-spacing: 0.15rem;
      padding: 1.2rem 0;
      text-align: left;
      width: 100%;

      .ar & {
        font-family: 'GE Dinkum';
      }      

      &.router-link-active, &--active {
        border-top: .05rem solid $gold;
        color: $gold; // $bottombar-text-color-active;
      }

      &[disable] {
        pointer-events: none;
      }

      &.active, &.router-link-active {
        // color: $lblue;
        // border-top: 1px solid $lblue;
      }
    }
  }

  &__nav-item {
    
    &--disabled {
      opacity: 0.4;
    }
  }
}

.slide-out {
  background: rgba($black, 0.8);
  border-radius: 0.5rem 0 0 0.5rem;
  bottom: 4rem;
  padding: 3rem;
  position: absolute;
  right: 100%;
  transform: translateX(calc(100%));
  transition: transform 0.6s ease-in-out;
  width: 25rem;

  &--slider-present {
    bottom: 23.2rem;
  }

  &--visible {
    transform: none;

    svg {
      transform: scaleX(-1);
    }
  }

  svg {
    transition: transform 0.6s ease-in-out;
  }
  
  &__toggle-button {
    align-items: center;
    background: rgba($black, 0.8);
    border-radius: 0.5rem 0 0 0.5rem;
    bottom: 4rem;
    display: flex;
    font-size: 2rem;
    height: 4rem;
    padding-left: 1.3rem;
    position: absolute;
    right: 100%;
    width: 4rem;
  }
}

.qrcode {
  background: $white;
  display: flex;
  padding: .4rem;
  width: max-content;

  canvas {
    height: 10rem !important;
    width: 10rem !important;
  }
}

.btn {
  color: $black;
  font-family: $touchscreen-font;
  font-size: 1.4rem;
  padding: 1rem 0 .8rem;
  text-transform: uppercase;
  width: 26rem;
  margin-bottom: 1rem;

  .ar & {
    font-family: 'GE Dinkum';
  }

  &--gold {
    @include btn($gold, $gold);
  }

  &--red {
    @include btn($red, $red);
    color: $white;
  }

  &--blue {
    @include btn($ddblue, $ddblue);
    color: $white;
  }
}
</style>